import { getAuthData } from '@/data/service/authService';
import { toast } from '@montugroup/design-system/Toast';
import { useSse } from '../sse/useSse';
import { WAITING_ROOM_NOTIFICATION_SUFFIX } from './useWaitingRoomNotification.config';
import { useWaitingRoomTracking } from './useWaitingRoomTracking';
import { WaitingRoomNotificationLink } from './WaitingRoomNotificationLink';

export const useWaitingRoomSseNotifications = () => {
  const { isDoc } = getAuthData();
  const { trackWaitingRoomNotification } = useWaitingRoomTracking();

  const calendarUrl = isDoc ? '/calendar' : '/nurse-calendar';

  // TODO: consultationId will be made not optional
  useSse({
    events: {
      waitingroom_status_queued: (message) => {
        const patientFullName = `${message.patientFirstName ?? ''} ${message.patientLastName ?? ''}`.trim();
        const patientDisplayName = patientFullName ? patientFullName : message.patientCode;

        toast.info({
          title: `${patientDisplayName} ${WAITING_ROOM_NOTIFICATION_SUFFIX}`,
          message: (
            <WaitingRoomNotificationLink calendarUrl={calendarUrl} consultationId={message.consultationId ?? 0} />
          ),
        });
        trackWaitingRoomNotification(message.consultationId ?? 0);
      },
    },
  });
};
